// One queue for ALL section/item reads in one curriculum attempt.
export const CURRICULUM_CHILD_CONCURRENCY = 3;

export function loadCurriculumChildren({ headers, readSections, readItems, signal }) {
  return new Promise((resolve, reject) => {
    const result = new Array(headers.length);
    const queue = [];
    let cursor = 0;
    let active = 0;
    let settled = false;
    const stop = error => {
      if (settled) return;
      settled = true;
      signal.removeEventListener("abort", abandon);
      queue.length = 0;
      reject(error);
    };
    const abandon = () => stop(Object.assign(new Error("Curriculum attempt abandoned"), { name: "AbortError" }));
    const run = job => {
      active++;
      // Each job awaits exactly one read; it never occupies a slot waiting on children.
      Promise.resolve().then(() => {
        if (settled || signal.aborted) return;
        return job();
      }).then(() => {
        active--;
        if (!settled) pump();
      }, stop);
    };
    const pump = () => {
      if (settled) return;
      if (signal.aborted) { abandon(); return; }
      while (active < CURRICULUM_CHILD_CONCURRENCY && cursor < queue.length) {
        run(queue[cursor++]);
      }
      if (active === 0 && cursor === queue.length) {
        settled = true;
        signal.removeEventListener("abort", abandon);
        resolve(result);
      }
    };
    signal.addEventListener("abort", abandon, { once: true });
    if (signal.aborted) { abandon(); return; }
    headers.forEach((h, hi) => {
      queue.push(async () => {
        const snapshot = await readSections(h.id);
        if (settled || signal.aborted) return;
        const header = { id: h.id, ...h.data(), sections: [] };
        result[hi] = header;
        header.sections = new Array(snapshot.docs.length);
        snapshot.docs.forEach((s, si) => {
          queue.push(async () => {
            const items = await readItems(h.id, s.id);
            if (settled || signal.aborted) return;
            header.sections[si] = { id: s.id, ...s.data(), items: items.docs.map(x => ({
              id: x.id, headerId: h.id, sectionId: s.id, ...x.data(),
            })) };
          });
        });
      });
    });
    pump();
  });
}
